import { sessionExpiredHeaderKey } from './sessionExpiredLink';
import isBrowser from '../util/isBrowser';

const fetchWrapper = async (
  input: RequestInfo,
  init?: RequestInit
): Promise<Response> => {
  const response = await fetch(input, init);

  if (isBrowser && response.headers.get(sessionExpiredHeaderKey)) {
    window.location.href = '/auth/sign_out';
  }

  return response;
};

export default fetchWrapper;
